(function() {
    'use strict';

    angular.module('dashboardApp').service('UsageTracker', Service);

    Service.$inject = [

        'AppSettings',
        'RequestWrapper'
    ];


    function Service(
        AppSettings,
        RequestWrapper
    ) {



        this.userList = function() {
            var request = {
                url: AppSettings.paths.api + 'UsageTracker/UserList'
            };

            return RequestWrapper.send(request);
        };


        this.usageData = function(userId, appId, startDate, endDate) {
            var params = {
                userId: userId,
                appId: appId,
                startDate: startDate,
                endDate: endDate
            };

            var request = {
                url: AppSettings.paths.api + 'UsageTracker/UsageData?' + $.param(params)
            };

            return RequestWrapper.send(request);
        };



        this.loginCounts = function(userId, appId, startDate, endDate) {
            var params = {
                userId: userId,
                appId: appId,
                startDate: startDate,
                endDate: endDate
            };

            var request = {
                url: AppSettings.paths.api + 'UsageTracker/LoginCounts?' + $.param(params)
            };

            return RequestWrapper.send(request);
        };



        this.export = function(userId, appId, startDate, endDate) {
            var params = {
                userId: userId,
                appId: appId,
                startDate: startDate,
                endDate: endDate
            };

            var url = AppSettings.paths.api + 'UsageTracker/Export?' + $.param(params);

	        window.open(url, '_export');
        };





    }

})();
